import { render, staticRenderFns } from "./Sip.vue?vue&type=template&id=683c6852&scoped=true&"
import script from "./Sip.vue?vue&type=script&lang=js&"
export * from "./Sip.vue?vue&type=script&lang=js&"
import style0 from "./Sip.vue?vue&type=style&index=0&id=683c6852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c6852",
  null
  
)

export default component.exports